import { getShopId } from '@amzn/rangoli-seller-desktop-utils/src/index';
import { useQuery } from 'react-query';

import { smartbiz } from './ApiClient';

export const getBusinessDetails = async () => {
  const storeId = await getShopId();
  try {
    const response = (await smartbiz.get(`stores/${storeId}/profiling/questions`)).data;
    return response;
  } catch (error) {
    console.error(error);
  }
};

const useGetBusinessDetails = () => {
  const { refetch } = useQuery('BusinessDetails', getBusinessDetails, {
    enabled: false,
  });
  return { refetch };
};

export default useGetBusinessDetails;
